module.exports = __webpack_public_path__ + "img/privilege3.0000730c.png";